var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFantasyOldMobile = function SvgFantasyOldMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 275,
    height: 123,
    fill: "none",
    viewBox: "0 0 275 123"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fantasy-old-mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fantasy-old-mobile_svg__b",
    width: 233,
    height: 30,
    x: 21,
    y: 93,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M254 93H21v30h233z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#fantasy-old-mobile_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fantasy-old-mobile_svg__c",
    width: 233,
    height: 30,
    x: 21,
    y: 93,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M254 93H21v30h233z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ff84ab",
    mask: "url(#fantasy-old-mobile_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m254 102.259-112.775-1.45c-.383 0-.767.138-1.058.416a1.46 1.46 0 0 0-.429 1.019c0 .37.138.741.429 1.018.291.294.675.432 1.058.417L254 102.228zM21 102.259l112.775-1.45c.383 0 .767.138 1.058.416.276.278.429.648.429 1.019s-.138.741-.429 1.018a1.4 1.4 0 0 1-1.058.417zM136.611 102.259c0-.494.398-.895.889-.895.49 0 .889.401.889.895a.893.893 0 0 1-.889.895.89.89 0 0 1-.889-.895M137.5 123l-1.426-16.821a1.46 1.46 0 0 1 .414-1.234 1.43 1.43 0 0 1 1.027-.417c.384 0 .736.139 1.027.417.338.339.476.802.414 1.234L137.531 123zM137.5 93c.705 1.111 2.33 4.738 1.165 6.389a1.45 1.45 0 0 1-2.33 0c-1.165-1.651.46-5.278 1.165-6.389"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old-mobile_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M259.257 27.558c-13.122 0-32.253 28.835-33.687 39.476-.33 2.48-.386 4.355 1.82 4.355.772 0 1.047.331.937 1.103l-.276 1.323c-.11.772-.496 1.103-1.268 1.103a65 65 0 0 0-12.239 0c-.386 0-1.103-.11-.937-1.103l.275-1.323c.11-.772.496-1.103 1.268-1.103 2.095 0 2.812-1.82 3.363-4.355.386-1.82.276-.938.662-3.253.165-.772.11-1.434-.11-2.15l-5.403-14.28c-.882-2.48-1.93-3.639-3.198-3.639-.772 0-1.048-.33-.882-1.102l.331-1.324c.165-.771.551-1.102 1.323-1.102 3.087.22 9.207.386 12.515 0 .386 0 .992.11.827 1.102l-.331 1.324c-.165.772-.551 1.102-1.323 1.102-2.481 0-2.536 2.316-2.15 3.584l3.032 9.483c.221.717.496.772.882.055 11.358-22.44 21.337-33.025 34.238-33.025 7.112 0 12.074 3.915 12.074 8.27 0 3.363-2.426 5.293-4.852 5.293-1.819 0-3.308-.937-3.969-2.481 1.323 0 2.04-1.71 2.04-2.757 0-2.315-1.709-4.576-4.962-4.576"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old-mobile_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M197.479 39.743c1.544 0 4.08.275 6.064 1.433l1.654-1.102c1.048-.662 1.93-.221 2.261.992l1.985 7.057v.33c0 .828-1.103 1.434-2.095 1.434-.772 0-1.544-.33-1.93-.992-1.709-2.867-3.914-5.183-7.664-5.183-1.929 0-4.465 1.103-4.465 3.64 0 5.237 13.507 8.324 13.507 17.752 0 6.947-6.23 10.861-13.452 10.861-5.514 0-12.571-2.205-12.571-7.939 0-3.584 2.702-5.403 5.128-5.403 1.433 0 2.867.606 3.639 2.205-1.379.386-2.206 1.544-2.206 2.867 0 2.26 1.93 4.521 6.065 4.521 3.584 0 5.734-2.205 5.734-5.017 0-6.781-13.618-8.711-13.618-17.863 0-6.34 6.561-9.593 11.964-9.593"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old-mobile_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M174.606 41.286c.552 5.128.882 10.255 1.489 15.383l1.323 11.081c.331 2.592 1.323 3.64 2.977 3.64.772 0 1.048.33.882 1.102l-.33 1.323c-.166.772-.552 1.103-1.324 1.103-3.363-.22-7.994-.386-11.633 0-.386 0-1.102-.11-.882-1.103l.331-1.323c.165-.772.551-1.103 1.323-1.103 2.095 0 1.654-1.764 1.434-4.355l-.166-2.15c-.055-.772-.386-1.103-1.158-1.103h-7.498c-.772 0-1.268.275-1.543.992l-1.434 3.143c-.937 2.26-.551 3.473 1.875 3.473.772 0 1.047.331.882 1.103l-.331 1.323c-.165.772-.551 1.103-1.323 1.103-3.97-.386-7.057-.386-11.082 0-.386 0-1.103-.11-.882-1.103l.331-1.323c.165-.772.551-1.103 1.323-1.103 2.371 0 4.08-2.095 5.293-4.631l10.31-21.281c.386-.993.275-1.765-.772-1.765-.386 0-1.158-.11-.938-1.102l.386-1.324c.221-.771.497-1.102 1.268-1.102 2.592.22 7.443.165 8.601 0 .772-.11 1.158.33 1.268 1.102m-6.009 18.58c.772 0 1.102-.33 1.047-1.102l-.661-8.822-.386-3.473-5.789 12.405c-.331.717-.166.992.606.992z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old-mobile_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M129.835 40.184c3.308.165 7.995.44 11.689.44 3.528 0 7.829-.22 12.074-.44.772-.055 1.378.22 1.599.992l2.37 8.601c.386 1.213-3.142 1.71-3.859.33-1.654-3.197-3.198-6.45-5.954-6.23-1.93.166-2.592 1.875-3.088 4.301-.882 3.97-2.867 14.886-3.363 18.856-.386 2.48-.386 4.355 1.82 4.355.771 0 1.047.331.937 1.103l-.276 1.323c-.11.772-.496 1.103-1.268 1.103a66 66 0 0 0-12.35 0c-.386 0-1.102-.11-.937-1.103l.276-1.323c.11-.772.496-1.103 1.268-1.103 2.095 0 2.867-1.82 3.363-4.355.937-3.97 2.812-14.886 3.363-18.856.386-2.812.165-4.3-2.095-4.3-2.647 0-5.348 3.253-6.782 6.175-.661 1.378-4.41.992-3.859-.331l3.474-8.546c.33-.717.827-1.047 1.598-.992"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old-mobile_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M117.136 73.595c-.165 1.157-.772 1.047-5.183 1.102-.771 0-1.268-.276-1.543-.992-.166-.662-5.789-17.974-9.704-26.63 0 .331-.055.662-.11.993-.937 3.97-2.757 14.996-3.308 18.966-.33 2.48-.386 4.355 3.143 4.355.771 0 1.047.331.937 1.103l-.276 1.323c-.11.772-.496 1.103-1.268 1.103a66 66 0 0 0-12.35 0c-.386 0-1.102-.11-.937-1.103l.276-1.323c.11-.772.496-1.103 1.268-1.103 2.757 0 4.135-1.82 4.686-4.355.882-3.97 2.757-14.997 3.308-18.966.33-2.536.276-4.356-3.142-4.356-.386 0-1.103-.11-.938-1.102l.276-1.324c.11-.771.496-1.102 1.268-1.102 1.489.165 7.333.496 11.302 0 1.103 0 1.379.275 1.709.937l7.94 21.722c.827-4.41 2.095-11.963 2.481-14.775.386-2.536.275-4.356-3.143-4.356-.386 0-1.103-.11-.937-1.102l.275-1.324c.111-.771.497-1.102 1.268-1.102 3.915.386 7.995.386 12.35 0 .772-.055 1.048.33.938 1.102l-.276 1.324c-.11.772-.496 1.102-1.268 1.102-2.812 0-4.19 1.82-4.686 4.356-1.71 7.277-3.419 18.414-4.356 25.527"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old-mobile_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M80.977 41.286c.552 5.128.882 10.255 1.489 15.383l1.323 11.081c.331 2.592 1.323 3.64 2.977 3.64.772 0 1.048.33.882 1.102l-.33 1.323c-.166.772-.552 1.103-1.323 1.103-3.364-.22-7.995-.386-11.634 0-.386 0-1.102-.11-.882-1.103l.331-1.323c.165-.772.551-1.103 1.323-1.103 2.095 0 1.654-1.764 1.434-4.355l-.166-2.15c-.055-.772-.386-1.103-1.157-1.103h-7.499c-.771 0-1.268.275-1.543.992l-1.434 3.143c-.937 2.26-.551 3.473 1.875 3.473.772 0 1.047.331.882 1.103l-.33 1.323c-.166.772-.552 1.103-1.324 1.103-3.97-.386-7.057-.386-11.082 0-.386 0-1.102-.11-.882-1.103l.33-1.323c.166-.772.552-1.103 1.324-1.103 2.37 0 4.08-2.095 5.293-4.631l10.31-21.281c.386-.993.275-1.765-.772-1.765-.386 0-1.158-.11-.937-1.102l.386-1.324c.22-.771.496-1.102 1.268-1.102 2.59.22 7.443.165 8.6 0 .772-.11 1.158.33 1.268 1.102m-6.01 18.58c.773 0 1.104-.33 1.048-1.102l-.661-8.822-.386-3.473-5.79 12.405c-.33.717-.165.992.607.992z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old-mobile_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M32.945 64.277c.496-2.867 2.646-14.114 2.922-16.099.386-2.536.276-4.355-1.82-4.355-.385 0-1.102-.11-.937-1.103l.276-1.434c.11-.771.496-1.102 1.268-1.102 7.222.276 14.39.276 21.612 0 .772-.055 1.268.276 1.6.992l2.59 8.711c.386 1.213-2.646 1.71-3.363.331-1.599-3.087-4.686-6.395-8.71-6.395h-1.986c-2.15 0-2.811 1.82-3.363 4.355-.386 1.765-1.323 6.01-1.543 7.388-.166.772.11 1.103.882 1.103h3.473c.772 0 2.04-.827 2.26-1.71l.221-.826c.166-.772.496-1.103 1.268-1.103h1.985c.772 0 1.158.33.937 1.103-.772 2.866-1.599 6.505-1.709 9.207-.11.772-.496 1.102-1.268 1.102h-1.985c-.772 0-1.102-.33-.937-1.102l.22-.993c.166-.992-.661-1.93-1.764-1.93h-3.308c-.716 0-1.213.497-1.268 1.103l-.606 3.529c-2.702 15.768-10.035 28.559-24.59 28.559C8.686 93.608 4 90.465 4 86.11c0-3.363 2.426-5.293 4.852-5.293 1.82 0 3.308.937 3.97 2.481-1.324 0-2.04 1.71-2.04 2.757 0 2.315 1.709 4.576 4.961 4.576 11.523 0 15.327-15.768 17.202-26.354"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old-mobile_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M205.026 1.095c.365 3.393.584 6.787.985 10.18l.876 7.335c.219 1.716.876 2.409 1.971 2.409.51 0 .693.219.583.73l-.219.876c-.109.51-.364.73-.875.73-2.226-.147-5.292-.256-7.7 0-.255 0-.73-.074-.584-.73l.219-.876c.11-.511.365-.73.876-.73 1.387 0 1.095-1.168.949-2.883l-.11-1.423c-.036-.511-.255-.73-.766-.73h-4.963c-.511 0-.839.183-1.022.657l-.948 2.08c-.621 1.496-.365 2.299 1.24 2.299.511 0 .694.219.584.73l-.219.876c-.109.51-.365.73-.876.73-2.627-.256-4.67-.256-7.334 0-.256 0-.73-.074-.584-.73l.219-.876c.109-.511.365-.73.876-.73 1.569 0 2.7-1.387 3.503-3.065l6.824-14.086c.255-.657.182-1.168-.511-1.168-.256 0-.767-.073-.621-.73l.256-.875c.146-.511.328-.73.839-.73 1.715.146 4.926.11 5.693 0 .511-.073.766.219.839.73m-3.978 12.297c.511 0 .73-.219.694-.73l-.438-5.838-.256-2.3-3.831 8.211c-.219.475-.11.657.401.657z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old-mobile_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M165.985.365c2.19.11 5.292.292 7.737.292 2.335 0 5.181-.146 7.991-.292.511-.037.912.146 1.058.657l1.569 5.692c.256.803-2.08 1.132-2.554.22-1.095-2.117-2.116-4.27-3.941-4.124-1.277.11-1.715 1.24-2.043 2.846-.584 2.627-1.898 9.853-2.226 12.48-.256 1.642-.256 2.883 1.204 2.883.511 0 .693.219.62.73l-.182.876c-.073.51-.329.73-.84.73-2.7-.256-5.4-.256-8.174 0-.255 0-.729-.074-.62-.73l.183-.876c.073-.511.328-.73.839-.73 1.386 0 1.897-1.204 2.226-2.883.62-2.627 1.861-9.853 2.226-12.48.255-1.86.109-2.846-1.387-2.846-1.751 0-3.54 2.153-4.488 4.087-.438.912-2.92.657-2.555-.22l2.299-5.655c.219-.475.548-.694 1.058-.657"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old-mobile_svg__m)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M139.318 13.83c0-7.08 5.474-13.83 13.502-13.83 5.583 0 9.889 3.54 9.889 10.145 0 7.006-5.401 13.83-13.356 13.83-5.839 0-10.035-3.613-10.035-10.145m13.319-11.495c-5.474 0-8.283 7.445-8.283 12.37 0 3.76 1.459 6.861 5.072 6.861 5.437 0 8.21-7.407 8.21-12.407 0-3.758-1.496-6.824-4.999-6.824"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#fantasy-old-mobile_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff84ab",
    d: "M134.488 22.479c-.109.766-.51.693-3.43.73-.511 0-.839-.183-1.022-.658-.109-.437-3.831-11.896-6.422-17.625 0 .22-.036.438-.073.657-.62 2.627-1.824 9.926-2.189 12.553-.219 1.642-.256 2.883 2.08 2.883.51 0 .693.219.62.73l-.183.875c-.072.511-.328.73-.839.73-2.7-.255-5.4-.255-8.174 0-.255 0-.73-.073-.62-.73l.182-.875c.073-.511.329-.73.84-.73 1.824 0 2.736-1.204 3.101-2.883.584-2.627 1.825-9.926 2.19-12.553.219-1.678.182-2.883-2.08-2.883-.256 0-.73-.073-.621-.73l.183-.875c.073-.511.328-.73.839-.73.985.11 4.854.328 7.481 0 .73 0 .912.182 1.131.62l5.255 14.378c.547-2.92 1.386-7.919 1.642-9.78.255-1.678.182-2.883-2.08-2.883-.256 0-.73-.073-.62-.73l.182-.875c.073-.511.328-.73.839-.73 2.591.255 5.292.255 8.174 0 .511-.037.694.219.621.73l-.183.875c-.073.511-.328.73-.839.73-1.861 0-2.773 1.205-3.102 2.883-1.131 4.817-2.262 12.188-2.883 16.896"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#ff84ab",
    filter: "url(#fantasy-old-mobile_svg__o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.709.289c1.01 0 2.67.18 3.969.938l1.083-.722c.686-.433 1.263-.144 1.48.65l1.299 4.62v.216c0 .541-.722.938-1.371.938-.506 0-1.011-.216-1.264-.65-1.118-1.876-2.562-3.392-5.016-3.392-1.263 0-2.923.722-2.923 2.382 0 3.429 8.842 5.45 8.842 11.621 0 4.548-4.078 7.11-8.806 7.11-3.61 0-8.229-1.444-8.229-5.197 0-2.346 1.769-3.537 3.357-3.537.938 0 1.876.397 2.382 1.444-.903.252-1.444 1.01-1.444 1.877 0 1.48 1.263 2.959 3.97 2.959 2.346 0 3.753-1.444 3.753-3.284 0-4.44-8.914-5.703-8.914-11.694 0-4.15 4.295-6.28 7.832-6.28M84.388 3.898C84.388 1.985 85.94 0 88.068 0c1.48 0 2.6 1.263 2.6 2.815 0 2.851-3.068 6.532-4.331 6.532-.397 0-.614-.288-.614-.577a.6.6 0 0 1 .108-.361c.867-.902 1.047-1.516 1.047-1.84 0-.109-.036-.145-.036-.145-1.48 0-2.454-1.083-2.454-2.526M64.628.578c2.166.108 5.234.288 7.651.288 2.31 0 5.125-.144 7.904-.288.505-.037.902.144 1.047.65l1.552 5.63c.252.793-2.057 1.118-2.527.216-1.082-2.093-2.093-4.223-3.897-4.078-1.264.108-1.697 1.227-2.021 2.815-.578 2.598-1.877 9.744-2.202 12.342-.253 1.625-.253 2.852 1.191 2.852.505 0 .686.216.614.721l-.18.867c-.073.505-.326.721-.83.721a43 43 0 0 0-8.085 0c-.253 0-.722-.072-.614-.721l.18-.867c.073-.505.326-.721.83-.721 1.372 0 1.878-1.191 2.202-2.852.614-2.598 1.841-9.744 2.202-12.342.252-1.841.108-2.815-1.371-2.815-1.733 0-3.501 2.129-4.44 4.042-.433.902-2.887.65-2.526-.217l2.274-5.594c.216-.469.541-.686 1.046-.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.63 23.314c-.253 0-.722-.072-.614-.722l.18-.866c.073-.505.325-.722.83-.722 1.372 0 1.841-1.19 2.202-2.85.577-2.6 1.84-9.817 2.201-12.416.217-1.66.18-2.85-1.19-2.85-.253 0-.722-.073-.614-.723l.18-.866c.073-.505.325-.722.83-.722 2.49.253 5.161.253 7.94 0 .506-.036.686.217.614.722l-.18.866c-.073.506-.325.722-.83.722-1.408 0-1.841 1.191-2.202 2.851-.578 2.599-1.84 9.817-2.202 12.415-.216 1.624-.252 2.851 1.191 2.851.506 0 .686.217.614.722l-.18.866c-.073.506-.325.722-.83.722a41.7 41.7 0 0 0-7.94 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old-mobile_svg__d",
    width: 69.465,
    height: 59.108,
    x: 205.536,
    y: 23.809,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10844_42153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10844_42153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old-mobile_svg__e",
    width: 36.669,
    height: 44.222,
    x: 176.773,
    y: 39.743,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10844_42153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10844_42153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old-mobile_svg__f",
    width: 41.829,
    height: 42.751,
    x: 143.495,
    y: 40.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10844_42153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10844_42153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old-mobile_svg__g",
    width: 40.889,
    height: 42.741,
    x: 120.708,
    y: 40.177,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10844_42153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10844_42153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old-mobile_svg__h",
    width: 49.232,
    height: 42.739,
    x: 82.513,
    y: 40.179,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10844_42153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10844_42153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old-mobile_svg__i",
    width: 41.829,
    height: 42.751,
    x: 49.866,
    y: 40.167,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10844_42153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10844_42153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old-mobile_svg__j",
    width: 64.49,
    height: 61.43,
    x: 0,
    y: 40.178,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10844_42153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10844_42153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old-mobile_svg__k",
    width: 30.39,
    height: 31,
    x: 183.082,
    y: 0.354,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10844_42153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10844_42153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old-mobile_svg__l",
    width: 29.768,
    height: 30.994,
    x: 158.592,
    y: 0.36,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10844_42153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10844_42153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old-mobile_svg__m",
    width: 31.391,
    height: 31.975,
    x: 135.318,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10844_42153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10844_42153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old-mobile_svg__n",
    width: 35.29,
    height: 30.993,
    x: 110.22,
    y: 0.361,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10844_42153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10844_42153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "fantasy-old-mobile_svg__o",
    width: 66.54,
    height: 32,
    x: 45,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10844_42153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10844_42153",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fantasy-old-mobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21 93h233v30H21z"
  })))));
};
export default SvgFantasyOldMobile;